import React from 'react';
import docDesignerHOC from '../docDesigner';

function PackingSlips() {
	return <div className="doc-designer">PackingSlips Design</div>;
}

const designerHOC = docDesignerHOC(PackingSlips);

export default designerHOC;
